module.exports = __webpack_public_path__ + "img/bental-kennedy.c05a059c.png";